import script from "./ListarBlocosAvaliacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarBlocosAvaliacoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarBlocosAvaliacoes.vue?vue&type=style&index=0&id=171bc641&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171bc641"]])

export default __exports__